<ms-my-bets-view [inputData]="repositoryResult" [isInitalLoadReadyFromRouteComponent]="isInitalLoadReady"></ms-my-bets-view>
